import React from 'react';
import { Package, TrendingUp, TrendingDown, AlertTriangle } from 'lucide-react';

export default function StockLevelCard({ 
  barrelType, 
  label, 
  price, 
  totalStock, 
  availableStock, 
  reservedStock, 
  status,
  threshold 
}) {
  const statusConfig = {
    good: {
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      textColor: 'text-green-800',
      iconColor: 'text-green-600',
      label: 'Stock Adéquat',
      icon: TrendingUp
    },
    warning: {
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-600',
      label: 'Stock Bas',
      icon: AlertTriangle
    },
    critical: {
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      textColor: 'text-red-800',
      iconColor: 'text-red-600',
      label: 'Stock Critique',
      icon: TrendingDown
    }
  };

  const config = statusConfig?.[status] || statusConfig?.good;
  const StatusIcon = config?.icon;

  return (
    <div className={`rounded-lg border-2 ${config?.borderColor} ${config?.bgColor} p-6 transition-all hover:shadow-md`}>
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`p-3 rounded-lg bg-white border ${config?.borderColor}`}>
            <Package size={24} className={config?.iconColor} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{label}</h3>
            <p className="text-sm text-gray-600">{price} € / unité</p>
          </div>
        </div>
        <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${config?.bgColor} border ${config?.borderColor}`}>
          <StatusIcon size={16} className={config?.iconColor} />
          <span className={`text-xs font-medium ${config?.textColor}`}>{config?.label}</span>
        </div>
      </div>
      {/* Stock Numbers */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Stock Total</span>
          <span className="text-2xl font-bold text-gray-900">{totalStock}</span>
        </div>
        
        <div className="h-px bg-gray-200"></div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Disponible</span>
          <span className={`text-xl font-semibold ${config?.textColor}`}>{availableStock}</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-600">Réservé</span>
          <span className="text-lg font-medium text-gray-700">{reservedStock}</span>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
          <span>Taux de disponibilité</span>
          <span>{totalStock > 0 ? Math.round((availableStock / totalStock) * 100) : 0}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all ${status === 'critical' ? 'bg-red-500' : status === 'warning' ? 'bg-yellow-500' : 'bg-green-500'}`}
            style={{ width: `${totalStock > 0 ? (availableStock / totalStock) * 100 : 0}%` }}
          ></div>
        </div>
      </div>
      {/* Threshold Info */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="grid grid-cols-3 gap-2 text-xs">
          <div>
            <p className="text-gray-500">Seuil Bas</p>
            <p className="font-medium text-gray-900">{threshold?.low}</p>
          </div>
          <div>
            <p className="text-gray-500">Critique</p>
            <p className="font-medium text-gray-900">{threshold?.critical}</p>
          </div>
          <div>
            <p className="text-gray-500">Réappro.</p>
            <p className="font-medium text-gray-900">{threshold?.reorder}</p>
          </div>
        </div>
      </div>
    </div>
  );
}